import React, { useState } from "react";
import { ProjectCard } from "../molecule/ProjectCard";
import { GridLayout} from "../components/layout";
import { StandardComp } from "../atoms/standardComp";
import { StandardButton } from "../atoms/buttons";

export function ProjectComp({ projects, onSelectProject }) {
 
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  function handleSelectProject(projectId) {
    setSelectedProjectId(projectId);
    if (onSelectProject) {
      onSelectProject(projectId);
    }
  }
  function mapStatus(status) {
  switch (parseInt(status)) {
    case 0:
      return "Inactief";
    case 1:
      return "Actief";
    case 2:
      return "Gepauzeerd";
    case 3:
      return "Afgerond";
    default:
      return "Onbekend";
  }
}

return (
  <GridLayout
    className="standard-padding"
    columnsTemplate="1fr 1fr 1fr 1fr"
    gap="1rem"
  >
    {projects.map((project) => {
      return (
        <ProjectCard
          key={project.id_workflow || project.id_campagne }
          title={project.project_name || project.campagne_name }
          afdeling={project.departments || []}
          cursus={project.total_courses}
          status={mapStatus(project.status)}
          beginDatum={project.min_start_date || project.min_publish_date || "-"}
          eindDatum={project.max_end_date || project.max_end_date || "-"}
          isSelected={selectedProjectId === project.id_workflow || project.id_campagne }
          open={() => handleSelectProject(project.id_workflow || project.id_campagne )}
        />
      );
    })}
  </GridLayout>
);

}
